export default "__VITE_ASSET__CczGGx_n__"